import { createContext, useContext } from "react";

export const VoiceContext = createContext();

export const useVoice = () => useContext(VoiceContext);